'use strict';

import resizeStore from '../resize/resize.store';


class ViewSlider extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._activeStart = 0;
    this._activeCount = 1;
    this._activeSlides = [];

    const t = +this.dataset.auto;
    this._autoTime = (!isNaN(t) && t > 0 ? t : 10) - 1;
    this._components = this.dataset.components || null;

    this.handleResize = (e) => this._onResize(e);
  }
  connectedCallback() {
    this._responsiveCount = +this.dataset.responsive || 1;
    this._count = +this.dataset.count || 1;
    this._counter = this.querySelector('.sliderCounter');

    this._controls = this.querySelector('.sliderControls');

    setTimeout(() => {
      this._slides = Array.from(this.querySelectorAll('.slide')).map((elem, index) => {
        if (elem.classList.contains('active')) this._activeStart = index;

        const components = Array.from(elem.querySelectorAll(this._components));

        const control = document.createElement('button');
        control.classList.add('slider-control');
        control.addEventListener('click', () => {
          if (this._activeStart === index) return;
          this._activeStart = index;
          this._activate();
        });

        if (this._controls) this._controls.appendChild(control);


        return {
          elem,
          index,
          textHeightEl: elem.querySelector('.sliderButtonsTop'),
          buttonsOffset: 0,
          components,
          control,
          activate: () => {
            elem.classList.add('active');
            control.classList.add('active');

            components.forEach(component => component.on());
          },
          deactivate: () => {
            elem.classList.remove('active');
            control.classList.remove('active');

            components.forEach(component => component.off());
          }
        }
      });

      this._buttonPrev = this.querySelector('.sliderButtonPrev');
      this._buttonNext = this.querySelector('.sliderButtonNext');

      if (this._buttonPrev) this._buttonPrev.addEventListener('click', () => this._prev());
      if (this._buttonNext) this._buttonNext.addEventListener('click', () => this._next());

      this._line = this.querySelector('.sliderLine');

      if (!this.classList.contains('scrl')) this.start();

      this._onResize(resizeStore.getData());
      resizeStore.eventEmitter.subscribe(this.handleResize);
    }, 0);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.unsubscribe(this.handleResize);
  }

  start() {
    this._activate();

    if (this._line && this._autoTime) {
      this._autoTween = TweenMax.fromTo(this._line, this._autoTime, {
        xPercent: '-100%'
      }, {
        xPercent: '0',
        ease: Power0.easeNone,
        onComplete: () => this._next()
        // paused: true,
      });
    }
  }

  _onResize(e) {
    this._activeCount = this._count;

    if (e.width < 1440) this._activeCount = this._responsiveCount;

    let offset = 0;

    this._slides.forEach(slide => {
      if (!slide.textHeightEl) return;

      slide.buttonsOffset = slide.textHeightEl.offsetHeight;
      for (let i = 0; this._activeCount > i; i++) {
        if (slide.index === this._activeStart + i) {
          offset = Math.max(offset, slide.buttonsOffset);
        }
      }
    });

    this.style.setProperty('--sliderButtonsTop', `${offset}px`);
  }


  _prev() {
    this._activeStart = this._activeStart - this._activeCount;

    if (this._activeStart < 0) this._activeStart = Math.ceil((this._slides.length - 1) / this._activeCount);

    this._activate();
  }
  _next() {
    this._activeStart = this._activeStart + this._activeCount;

    if (this._activeStart > this._slides.length - 1) this._activeStart = 0;

    this._activate();
  }
  _activate() {
    this._activeSlides.forEach(slide => slide.deactivate());
    this._activeSlides = [];

    let offset = 0;

    for (let i = 0; this._activeCount > i; i++) {
      const active = this._activeStart + i;
      if (!this._slides[active]) continue;

      const slide = this._slides[active];
      this._activeSlides.push(slide);

      if (slide.textHeightEl) {
        offset = Math.max(offset, slide.buttonsOffset);
      }

      if (this._line && this._autoTime) {
        TweenMax.to(this._line, 1, {
          xPercent: '100%',
          overwrite: 'all',
          onComplete: () => this._autoTween.play(0)
        });
      } else if (this._autoTime) {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this._next(), this._autoTime * 1000);
      }

      slide.activate();
    }

    if (this._counter) {
      this._counter.innerHTML = `${this._activeStart + 1}/${this._slides.length}`;
    }

    this.style.setProperty('--sliderButtonsTop', `${offset}px`);
  }
}

window.customElements.define('view-slider', ViewSlider);